var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    _vm._b({ attrs: { outlined: "" } }, "v-card", _vm.$attrs, false),
    [
      !_vm.hideTitle
        ? _c(
            "v-card-title",
            {
              class: [
                "py-1 text-subtitle-1 font-weight-regular",
                _vm.classTitle,
              ],
            },
            [
              _vm._t("title", function () {
                return [
                  _vm.icon
                    ? _c("v-icon", { attrs: { left: "", small: _vm.small } }, [
                        _vm._v(_vm._s(_vm.icon)),
                      ])
                    : _vm._e(),
                  _vm._v(" " + _vm._s(_vm.title)),
                ]
              }),
              _c("v-spacer"),
              _vm._t("tools"),
              !_vm.noBtnCreate
                ? _c("ButtonsCreateIcon", {
                    on: {
                      clicked: function ($event) {
                        return _setup.emit("clickedCreateButton")
                      },
                    },
                  })
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _c("v-card-text", [_vm._t("default")], 2),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }